import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from 'components/button/button'
import { reassignGuestProjects } from 'state/actions'
import GuestList from 'components/modal/modal-components/guest-list'

import { forIn } from 'lodash'
import copy from 'fast-copy'

import {
	getCurrentAccount,
	isPremium,
	getCurrentUser,
	getUserRoles
} from 'state/selectors'

import SearchMini from 'components/search-mini/search-mini'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class ModalAssignProjects extends Component {
	state = {
		projectList: [],
		includedProjectIds: [],
		searchTerm: ''
	}

	componentDidMount() {
		const tempProjectArray = []

		forIn(this.props.allProjects, project => {
			if (project.account_id == this.props.accountData.id) {
				tempProjectArray.push(project)
			}
		})

		let tempState = {}

		tempState.projectList = tempProjectArray

		const projectIds = this.props.data.user ? this.props.data.user.projectIds : this.props.data.team.projectIds

		tempState.includedProjectIds = [
			...projectIds
		]

		this.setState(tempState)
	}

	save = _ => {
		const {
			isLoading,
			data,
			reassignGuestProjects,
			handleSuccess,
			closeCallback
		} = this.props

		if (isLoading) {
			return
		}

		let requestData = {
			projectIds: this.state.includedProjectIds,
			id: data.type == 'guest' ? data.user.id : data.team.id
		}

		const type = data.type == 'guest' ? 'user' : 'team'

		reassignGuestProjects(requestData, type)

		const entityName = data.type == 'guest' ? data.user.first_name : data.team.name

		handleSuccess(`We've updated ${entityName}'s projects, and notified them accordingly.`)

		setTimeout(_ => {
			closeCallback()
		}, 2000)
	}

	handleChange = (value, input) => {
		this.setState({
			[input]: value
		})
	}

	handleIncludedChange = project => {
		let includedProjectIds = copy(this.state.includedProjectIds)

		const indexIfExists = includedProjectIds.findIndex(projectId => {
			return projectId == project.id
		})

		if (indexIfExists == -1) {
			includedProjectIds.push(project.id)
		} else {
			includedProjectIds.splice(indexIfExists, 1)

		}

		this.setState({
			includedProjectIds
		})
	}


	render() {
		const {
			projectList,
			includedProjectIds,
			searchTerm
		} = this.state

		const {
			data,
			closeCallback,
			validateResponse,
			handleDismiss,
		} = this.props

		let className = 'modal-assign-projects clear'

		let tempProjectList = [
			...projectList
		]

		let copy = ''

		if(data.type == 'guest'){
			copy = `${data.user.first_name} ${data.user.last_name} is currently `

			if (data.user.projectIds.length) {
				copy += `a guest on ${data.user.projectIds.length} project${data.user.projectIds.length != 1 ? 's' : ''}.`
			} else {
				copy += 'not a guest on any projects.'
			}
		}else{
			copy = `${data.team.name} is currently `

			if(data.team.projectIds.length){
				copy += `assigned to ${data.team.projectIds.length} project${data.team.projectIds.length != 1 ? 's' : ''}`
			}else{
				copy += `not assigned to any projects.`
			}
		}

		tempProjectList = tempProjectList.filter(project => {
			return project.name.toLowerCase().includes(searchTerm.toLowerCase())
		})

		tempProjectList.sort((a, b) => {
			if (a.name < b.name) return -1
			if (a.name > b.name) return 1
			return 0
		})

		tempProjectList.sort((a, b) => {
			const aChecked = includedProjectIds.indexOf(a.id) !== -1
			const bChecked = includedProjectIds.indexOf(b.id) !== -1

			return (aChecked === bChecked) ? 0 : aChecked ? -1 : 1
		})

		let title = ''

		if(data.type == 'guest'){
			if (data.user.first_name) {
				title = `${data.user.first_name}'s projects`
			}
		}else{
			title = `${data.team.name}'s projects`
		}

		return (
			<div>
				<div className={className}>
					<h2>
						{title}
					</h2>
					<span className="disclaimer">
						{copy}
					</span>
					<div className="input-wrap">
						<SearchMini
							searchTerm={searchTerm}
							onSearchTermChange={value => this.handleChange(value, 'searchTerm')}
						/>
						<GuestList
							users={tempProjectList}
							handleChangeUsers={project => { this.handleIncludedChange(project) }}
							includedKeyArrays={[includedProjectIds]}
							checkKeys={['id']}
							isProjects={true}
							canSelect={true}
						/>
					</div>
				</div>
				<ValidateResponse dismissCallback={handleDismiss} response={validateResponse} />
				<Button size={'big'} level={'high'} callback={this.save} label={data.type == 'guest' ? 'Save guest' : 'Save team'} icon={'check'} />
				<Button size={'big'} level={'low'} callback={closeCallback} label={'Cancel'} />
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
		operation: state.modal.operation,
		allProjects: state.account.entities.projects,
		currentUser: getCurrentUser(state),
		isPremium: isPremium(state),
		userRoles: getUserRoles(state),
	};
}

const ModalAssignProjectsWithValidateResponse = withValidateResponse(ModalAssignProjects)

export default connect(mapStateToProps, {
	reassignGuestProjects
})(ModalAssignProjectsWithValidateResponse)
